import style from './LowerHeader.css';
import logo from './../../../img/logo.png';
import phone from './../../../img/phone-icon.svg';
import liked from './../../../img/liked.svg';
import basket from './../../../img/basket.svg';
import isMobile from "../../../assets/Tools/isMobile";
import {useEffect, useState} from "react";
import classNames from "classnames/bind";
import MenuItems from "./MenuItems";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";


const LowerHeader = (props) => {
    const basketData = useSelector(state => state.setOrder.productsToOrder);
    const likedCount = useSelector(state => state.setLiked.count);


    useEffect(() => {
        if (isMobile.any()) {
            document.body.classList.add('_touch');
        } else {
            document.body.classList.add('_pc');
        }
    })


    return (
        <div className="navigation">
            <div className="navigation__content content">
                <div className="navigation__left">
                    <Link to="/"><img src={logo} alt="логотип веб-сайта" className="navigation__logo"/></Link>
                    {/*Основное меню*/}
                    <nav className={props.menuClass}>
                        <ul className="menu__list">
                            <MenuItems link="categories" isSublist={true}>КАТЕГОРИИ</MenuItems>
                            <MenuItems link="brands">БРЕНДЫ</MenuItems>
                            <MenuItems link="info">ИНФОРМАЦИЯ</MenuItems>
                            <MenuItems link="about">О КОМПАНИИ</MenuItems>
                            <MenuItems link="news">НОВОСТИ</MenuItems>
                            <MenuItems link="contacts">КОНТАКТЫ</MenuItems>
                        </ul>
                    </nav>
                </div>
                <div className="navigation__right">
                    <div className="navigation__phone phone">
                        <h5>066-677-55-33</h5>
                        <button className="phone__btn"><img src={phone} alt="иконка телефона"/>Перезвоните
                            мне
                        </button>
                    </div>
                    <div className="navigation__icons">
                        <div className="navigation__liked"><Link to="account/liked"><img src={liked} alt="Понравилось"/>
                            <div className="counter"><span>{likedCount}</span></div>
                        </Link>
                        </div>
                        <div className="navigation__bracket"><Link to="basket"><img src={basket} alt="Корзина товаров"/>
                            <div className="counter"><span>{basketData.length}</span></div>
                        </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LowerHeader;